module.exports = __webpack_public_path__ + "asset/school--161d47.svg";